<template>
    <div>
        <header class="b-blue">
            <div class="container">
                <div class="row">
                    <div class="col-md-7 py-5 col-sm-12">
                        <div class="_description-head d-flex">
                            <h3 class="font-weight-light">En Kllaar.com te ofrecemos planes que se adaptan
                                a tus necesidades como empleador.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <div class="row">
            <div class="col-lg-12">
                <div class="text-center py-5" v-show="downloading">
                    <b-spinner small label="Espere ..."></b-spinner>
                    <br>
                    <small>Espere un momento...</small>
                </div>
            </div>
        </div>

        <section  v-if="!downloading && !extra">
            <div class="container">
                <div class="row my-5">
                    <PlanGratis />
                    <PlanPlata />
                    <PlanOro />
                </div>
            </div>
        </section>

        <section v-if="!downloading && extra">
            <div class="container mt-5">
                <PlanCandidates :extra="extra" />
            </div>
        </section>
    </div>
</template>
<script>
import PlanGratis from './components/PlanGratis'
import PlanPlata from './components/PlanPlata'
import PlanOro from './components/PlanOro'

import PlanCandidates from './components/PlanCandidates'
export default {
    components:{
        PlanGratis,
        PlanPlata,
        PlanOro,
        PlanCandidates
    },
    data() {
        return {
            downloading: false,
            extra: false,
        }
    },
    computed: {

    },
    methods:{
        isPlan(){
            this.downloading = true
            this.api.get('member/payment_extra').then(({data}) => {
                this.extra = data
                this.downloading = false
            }).catch(err => {

            })
        }
    },
    created() {
        let params = this.$route.query
        if(params.addcandidates){
            this.isPlan()
        }
    },

}
</script>



// WEBPACK FOOTER //
// src/components/#public/member/MemberHome.vue